import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AllocationTemplateDocumentFieldsFragment = { __typename?: 'AllocationTemplateDocument', id: string, name: string, equalizeWeeksOfSupply: boolean, favorHigherWeight: boolean, mode: Types.AllocationMode, targetWeeksOfSupply?: number | null, allocationType: Types.AllocationType, priorities: Array<Types.AllocationPriorityDimension> };

export type AllocationTemplateFragment = { __typename?: 'AllocationTemplateData', id: string, name: string, equalizeWeeksOfSupply: boolean, favorHigherWeight: boolean, mode: Types.AllocationMode, targetWeeksOfSupply?: number | null, allocationType: Types.AllocationType, priorities: Array<Types.AllocationPriorityDimension> };

export type GetAllocationTemplatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllocationTemplatesQuery = { __typename?: 'Query', allocationTemplates?: { __typename?: 'AllocationTemplatesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'AllocationTemplateDocument', id: string, name: string, equalizeWeeksOfSupply: boolean, favorHigherWeight: boolean, mode: Types.AllocationMode, targetWeeksOfSupply?: number | null, allocationType: Types.AllocationType, priorities: Array<Types.AllocationPriorityDimension> }> | null } | null };

export type GetUnallocatedAvailabilityQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  itemId: Types.Scalars['String']['input'];
  stationCode: Types.Scalars['String']['input'];
}>;


export type GetUnallocatedAvailabilityQuery = { __typename?: 'Query', restockSession?: { __typename?: 'RestockSessionStateData', sessionId: string, unallocatedAvailability: number } | null };

export const AllocationTemplateDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment AllocationTemplateDocumentFields on AllocationTemplateDocument {
  id
  name
  equalizeWeeksOfSupply
  favorHigherWeight
  mode
  targetWeeksOfSupply
  allocationType
  priorities
}
    `, {"fragmentName":"AllocationTemplateDocumentFields"});
export const AllocationTemplateFragmentDoc = new TypedDocumentString(`
    fragment AllocationTemplate on AllocationTemplateData {
  id
  name
  equalizeWeeksOfSupply
  favorHigherWeight
  mode
  targetWeeksOfSupply
  allocationType
  priorities
}
    `, {"fragmentName":"AllocationTemplate"});
export const GetAllocationTemplatesDocument = new TypedDocumentString(`
    query GetAllocationTemplates($first: Int, $after: String) {
  allocationTemplates(first: $first, after: $after) {
    pageInfo {
      ...PageInfo
    }
    totalCount
    nodes {
      ...AllocationTemplateDocumentFields
    }
  }
}
    fragment AllocationTemplateDocumentFields on AllocationTemplateDocument {
  id
  name
  equalizeWeeksOfSupply
  favorHigherWeight
  mode
  targetWeeksOfSupply
  allocationType
  priorities
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetUnallocatedAvailabilityDocument = new TypedDocumentString(`
    query GetUnallocatedAvailability($sessionId: String!, $itemId: String!, $stationCode: String!) {
  restockSession(sessionId: $sessionId) {
    sessionId
    unallocatedAvailability(itemId: $itemId, stationCode: $stationCode)
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllocationTemplates: build.query<GetAllocationTemplatesQuery, GetAllocationTemplatesQueryVariables | void>({
      query: (variables) => ({ document: GetAllocationTemplatesDocument, variables })
    }),
    GetUnallocatedAvailability: build.query<GetUnallocatedAvailabilityQuery, GetUnallocatedAvailabilityQueryVariables>({
      query: (variables) => ({ document: GetUnallocatedAvailabilityDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllocationTemplatesQuery, useLazyGetAllocationTemplatesQuery, useGetUnallocatedAvailabilityQuery, useLazyGetUnallocatedAvailabilityQuery } = injectedRtkApi;
